import auth from "./modules/auth";
import users from "@/modules/users/router";
import contracts from "@/modules/contracts/router";
import userTasks from "@/modules/cabinet/tasks/router";
import expenses from "@/modules/expenses/router";
import sells from "@/modules/sells/router";
import unallocatedOperations from "@/modules/unallocated-operations/router";
import transfer from "@/modules/transfers/router";
import payrolls from "@/modules/payrolls/router";
import salary from "@/modules/salary/router";
import plannedExpenses from "@/modules/planned-expenses/router";
import splitExpenses from "@/modules/split-expenses/router";
import clients from "@/modules/clients/router";

import reportMargin from "@/modules/reports/report-margin/router";
import reportWalletBalances from "@/modules/reports/report-wallets-balances/router";
import reportCompanyProfit from "@/modules/reports/report-company-profit/router";
import reportEmployees from "@/modules/reports/report-employees/router";
import updateData from "@/modules/update-data/router";
import reportEfficiency from "@/modules/reports/report-efficiency/router";
import productionCalendar from "@/modules/production-calendar/router";

// Разделы clients/users/contracts/report-efficiency/production-calendar раньше скрывались на проде
// (prodGuard + hideOnProd по VUE_APP_ENV). Запущены в релизе 28.09.2026 (NANFin-249) — guard снят.
export default [
  {
    path: "/",
    name: "default",
    meta: {
      title: "Dashboard",
      authRequired: true,
    },
    component: () => import("@/views/default.vue"),
  },
  {
    path: "/403",
    name: "Forbidden",
    meta: { title: "403", authRequired: false },
    component: () => import("@/views/403.vue"),
  },
  {
    path: "/:pathMatch(.*)*",
    name: "NotFound",
    meta: {
      title: "404",
      authRequired: false,
    },
    component: () => import("@/views/404.vue"),
  },
  ...auth,
  ...users,
  ...contracts,
  ...userTasks,

  ...expenses,
  ...sells,
  ...transfer,
  ...updateData,

  ...unallocatedOperations,

  ...payrolls,
  ...salary,

  ...plannedExpenses,
  ...splitExpenses,
  ...clients,

  ...reportMargin,
  ...reportWalletBalances,
  ...reportCompanyProfit,
  ...reportEmployees,
  ...reportEfficiency,
  ...productionCalendar,
];
